import { HHIconButton, HHTooltip } from '@hinge-health/react-component-library';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { GridColDef } from '@mui/x-data-grid-pro';
import { BatchImportRow } from './csv-utils';

const statusIcons: Record<
  NonNullable<BatchImportRow['status']>,
  JSX.Element
> = {
  success: <CheckCircleOutlineIcon color="success" fontSize="small" />,
  error: <ErrorOutlineIcon color="error" fontSize="small" />,
};

const formatCap = (value: number | null): string => {
  if (value === null || value === undefined) return '';
  return value.toLocaleString('en-US');
};

export const getBatchImportColumns = (
  onDeleteRow: (rowId: string) => void,
  clientNameMap: Record<number, string>,
): GridColDef<BatchImportRow>[] => [
  {
    field: 'status',
    headerName: 'Status',
    width: 80,
    editable: false,
    sortable: false,
    renderCell: params =>
      statusIcons[params.value as NonNullable<BatchImportRow['status']>],
  },
  {
    field: 'clientId',
    headerName: 'Client ID',
    width: 120,
    editable: true,
    type: 'number',
    valueFormatter: params =>
      params.value !== null && params.value !== undefined
        ? String(params.value)
        : '',
  },
  // ACCOUNTS-AND-PLAN-MIGRATION: params.row.clientId is client-scoped, not resolvable via contract_id — will be addressed by the Accounts & Plan migration.
  {
    field: 'clientName',
    headerName: 'Client Name',
    width: 180,
    editable: false,
    sortable: false,
    valueGetter: params =>
      params.row.clientId !== null
        ? (clientNameMap[params.row.clientId] ?? 'Unknown Client')
        : 'Unknown Client',
  },
  {
    field: 'cap',
    headerName: 'Cap',
    width: 130,
    editable: true,
    type: 'number',
    valueFormatter: params => formatCap(params.value),
  },
  {
    field: 'startDate',
    headerName: 'Start Date (YYYY-MM-DD)',
    width: 190,
    editable: true,
    type: 'string',
  },
  {
    field: 'endDate',
    headerName: 'End Date (YYYY-MM-DD)',
    width: 190,
    editable: true,
    type: 'string',
  },
  {
    field: 'error',
    headerName: 'Error',
    flex: 1,
    minWidth: 200,
    editable: false,
    sortable: false,
    renderCell: params =>
      params.value ? (
        <HHTooltip hhVariant="bottom" title={params.value as string}>
          <span
            style={{
              color: '#d32f2f',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {params.value as string}
          </span>
        </HHTooltip>
      ) : null,
  },
  {
    field: 'actions',
    headerName: '',
    width: 60,
    editable: false,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: params => (
      <HHIconButton
        hhVariant="variant-bypass"
        size="small"
        onClick={(): void => onDeleteRow(params.row.rowId)}
        aria-label="delete row"
        data-testid={`delete-row-${params.row.rowId}`}
      >
        <DeleteOutlineIcon fontSize="small" />
      </HHIconButton>
    ),
  },
];
